import React from "react";
import PageHeading from "../components/PageHeading";
import DCard from "../components/DCard";
import DImage from "../components/DImage";
import Avatar from "../assets/avatar.png";
import FormikContainer from "../components/Formik/FormikContainer";
import FieldContainer from "../components/Formik/FieldContainer";
import { Form } from "formik";
import DButton from "../components/DButton";
import { Spinner } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import userServices from "../services/users";
import { toast } from "react-hot-toast";
import authServices from "../services/auth";
import { setCookie } from "../utils/functions";
import { setAuth } from "../redux/slicers/config";
const validationSchema = Yup.object().shape({
    username: Yup.string()
        .min(4, "على الاقل 4 محارف")
        .required("هذا الحقل مطلوب"),
    password: Yup.string()
        .min(8, "على الاقل 8 محارف")
        .required("هذا الحقل مطلوب"),
});
const Profile = ({ title }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { auth } = useSelector(state => state.config);

    const onSubmit = (values, { setSubmitting }) => {
        const data =
            values.password !== "" ? values : { username: values.username };
        userServices
            .updateUser(data, 1)
            .then(res => {
                toast.success("تم التحديث بنجاح يرجى تسجيل الدخول مرة اخرى");
                setTimeout(() => {
                    authServices.logout();
                    setCookie("dc-auth", "", -1);
                    dispatch(setAuth({}));
                    navigate("/login", { replace: true });
                }, 1500);
            })
            .catch(err => {
                console.log(err);
                toast.error("فشل التعديل");
                setSubmitting(false);
            });
    };
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard>
                <div className="relative w-[250px] mx-auto rounded-full overflow-hidden p-4 mb-4 bg-light-color">
                    <DImage src={Avatar} alt={Avatar} />
                </div>
                <FormikContainer
                    onSubmit={onSubmit}
                    validationSchema={validationSchema}
                    initialValues={{
                        username: auth.username || "",
                        password: "",
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="w-full sm:w-2/4 2xl:w-1/4 mx-auto ">
                                <FieldContainer
                                    name="username"
                                    label="اسم الحساب"
                                    id="username"
                                />

                                <FieldContainer
                                    name="password"
                                    label="تغيير كلمة المرور"
                                    id="password"
                                />
                                <DButton
                                    disabled={isSubmitting}
                                    type="submit"
                                    className="flex items-center justify-center mx-auto text-white w-2/4"
                                >
                                    {isSubmitting ? <Spinner /> : "حفظ"}
                                </DButton>
                            </div>
                        </Form>
                    )}
                </FormikContainer>
            </DCard>
        </div>
    );
};

export default Profile;
